// extracted by mini-css-extract-plugin
export var container = "styles-module--container--23d41";
export var widget = "styles-module--widget--eab8e";